import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

const Image = styled.img`
        height: 4.5em;
        
        @media (max-width: 758px) {
            height: 3.5em;
            padding: 0 1rem;
        }
    `

const Logo = () => {
    
    return (    
        <NavLink to="/">
            <Image src="/logo.png" alt="logo.png"></Image>
        </NavLink>
        
    )
}

export default Logo
